import type { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import store from "@/store/store";
import { BreakpointProvider } from "@/contexts/BreakpointContext";

const AppProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ReduxProvider store={store}>
      <BreakpointProvider>{children}</BreakpointProvider>
    </ReduxProvider>
  );
};

export default AppProvider;
